module.exports = __webpack_public_path__ + "img/symbol_7.f3ed0ea8.png";